<script lang="ts">
  import type { SkillCategory, SkillCategorySummary } from '$lib/api/types';
  import BadgeGridItem from './BadgeGridItem.svelte';

  interface Props {
    greyscaleOnIncomplete?: boolean;
    classId: number;
    badgeProgress: SkillCategorySummary[];
    courseSkillCategories: SkillCategory[];
    /**
     * If provided, the badges whose skill category exist in this list will animate on mount.
     */
    formerIncompleteSkillCategories?: number[];
  }

  let { classId, badgeProgress, courseSkillCategories, formerIncompleteSkillCategories, greyscaleOnIncomplete }: Props =
    $props();
</script>

<div class="skill-category-grid">
  {#each badgeProgress as badgeProgressItem (badgeProgressItem.skillCategoryId)}
    <a href="/classes/{classId}/badges/{badgeProgressItem.skillCategoryId}" class="btn grid-item">
      <BadgeGridItem
        {greyscaleOnIncomplete}
        category={courseSkillCategories.find(x => x.id === badgeProgressItem.skillCategoryId)!}
        possibleSkillCount={badgeProgressItem.possibleSkillCount}
        completedSkillCount={badgeProgressItem.completedSkillCount}
        animateOnMount={formerIncompleteSkillCategories &&
          formerIncompleteSkillCategories.includes(badgeProgressItem.skillCategoryId) &&
          badgeProgressItem.completedSkillCount === badgeProgressItem.possibleSkillCount}
      />
    </a>
  {/each}
</div>

<style>
  .skill-category-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    gap: 2rem;
  }

  .grid-item {
    --bs-btn-hover-bg: var(--bs-secondary-bg);
  }
</style>
